import React, {useEffect} from "react";
import {useLocation} from "react-router-dom";
import {classNameScrollbar} from "./tools/CommonHtml";
import {useColorModeTheme, UseAsComponent} from "./tools/CommonReact";
import {LazyRoutes, useLevelNavigation} from "./tools/LevelNavigation";
import {usePopPanel} from "./tools/UIPopPanel";
import {hideTooltip, registerTooltipCtrl} from "./tools/Tooltip";
import {useDialogs} from "./tools/UIDialog";
import {appCtx} from "./app/AppContext";
import {CheckAuth} from "./app/Auth";
import {CheckLicense} from "./app/UseLicense";
import {defaultPath, helpActions, menu, routes} from "./routes";
import {SideBar} from "./views/SideBar";
import {NavBar} from "./views/NavBar";
import {ClientNoticeCIS, ClientNoticeEOL} from "./views/ClientNotice";
import {ErrorBoundary} from "./tools/errorBoundary/ErrorBoundary";

export function App() {
    useColorModeTheme();
    const {panelCtrl, panelJsx} = usePopPanel();
    Object.assign(appCtx, {tooltip: panelCtrl});
    registerTooltipCtrl(panelCtrl);

    const {pathname} = useLocation();
    useEffect(() => { hideTooltip(); }, [pathname]);    // anchor unmounts before mouseleave can fire on link-driven nav; clear any lingering tooltip.

    appCtx.nav = useLevelNavigation(routes, defaultPath);
    if (appCtx.nav.redirected)
        return null;

    return (<>
        <CheckAuth>
            <CheckLicense>
                <div className="flex">
                    <SideBar {...{menu, helpActions}}/>
                    <div data-test="page-background" className="grow flex flex-col bg-bg1 h-screen overflow-hidden relative">
                        <div className="flex flex-col gap-3 absolute bottom-4 z-10 right-4 w-1/3">
                            <ClientNoticeEOL/>
                            <ClientNoticeCIS isOn={appCtx.nav.getCurPath().startsWith("/custom_policy")}/>
                        </div>
                        <NavBar/>
                        <ErrorBoundary>
                            <div
                                className={`p-8 grow h-full relative overflow-auto ${classNameScrollbar} outline-none`}
                                tabIndex={0} ref={el => el && document.activeElement === document.body && el.focus()}>
                                <LazyRoutes {...{routes, defaultPath}}/>
                            </div>
                        </ErrorBoundary>
                    </div>
                </div>
            </CheckLicense>
        </CheckAuth>
        <UseAsComponent use={useDialogs} ctrl={appCtx} toJsx={ctrl => ctrl.dialogsJsx}/>
        {panelJsx}
    </>);
}
